/**
 * @module AuthSaga
 */

import store from "../store";
import { notificationActions } from "./saga";

export function setNotifications(data) {
  store.dispatch({
    type: notificationActions.SET_NOTIFICATION,
    payload: data
  });
}

export function updateNotification(UpdateType, ruleId, docId) {
  store.dispatch({
    type: notificationActions.UPDATE_NOTIFICATION,
    payload: {
      ruleId: ruleId,
      updateType: UpdateType,
      documentId: docId
    }
  });
}

export const loadMoreNotifications = (data) => {
  store.dispatch({
    type: notificationActions.LOAD_MORE_NOTIFICATIONS,
    payload: data
  });
};
export const updateUnreadCount = () => {
  store.dispatch({
    type: notificationActions.SET_UNREAD_NOTIFICATION_COUNT
  });
};
